const WORKSPACE_REPO_ROUTE_PREFIXES = [
  '/sia/components/code_analysis/inventory',
  '/sia/components/code_analysis/build_analysis',
  '/sia/components/code_analysis/test-optimization',
  '/sia/components/code_analysis/test-cases',
  '/sia/components/code_analysis/call-graph',
  '/sia/components/coverage_analysis/dashboard',
  '/sia/components/coverage_analysis/manual',
  '/sia/components/coverage_analysis/automation',
  '/sia/components/coverage_analysis/trend',
  '/sia/components/coverage_analysis/test-gap-analysis',
  '/sia/components/manual-testing',
  '/sia/components/releases',
] as const;

/** Mongo ``repositories._id`` segment when inside a component workspace route. */
export function getWorkspaceRepoIdFromPath(pathname: string): string | undefined {
  const releasesPrefix = '/sia/components/releases/';
  if (pathname.startsWith(releasesPrefix)) {
    const tail = pathname.slice(releasesPrefix.length);
    const segment = tail.split('/')[0];
    if (segment && segment !== 'execution') {
      return segment;
    }
  }

  for (const base of WORKSPACE_REPO_ROUTE_PREFIXES) {
    const prefix = `${base}/`;
    if (!pathname.startsWith(prefix)) {
      continue;
    }
    const segment = pathname.slice(prefix.length).split('/')[0];
    if (segment && segment !== 'execution') {
      return segment;
    }
  }

  return undefined;
}

export function isComponentsListPath(pathname: string): boolean {
  return pathname === '/sia/components' || pathname === '/sia/components/';
}
